export default __webpack_public_path__ + "static/media/checkmark.a1c402d8.svg";